import { Injectable, EventEmitter } from '@angular/core';
import { FormBuilderControl, ILookupSelectItem } from '../../common/formbuilder/FormBuilderControl';
import { ApiService } from '../api/api.service';
import { IdentityAuthService } from '../identity-auth/identity-auth.service';
import { appSettings } from '../../modules/shared/components/appSettings';
import { delay } from 'rxjs/operators';
import * as _ from 'underscore';

export interface IContalLookupCache {
  endpointUrl: any;
  dbField: any;
  lookups: Array<ILookupSelectItem>
}


@Injectable({
  providedIn: 'root'
})
export class SharedFiltersService {
  public loading: boolean;
  private currentlyLoadingTask: any;
  private _loadFilters = false;
  public advancedFiltersOpened: boolean = false;
  public reportsOpened: boolean = false;
  public includeAllCheckboxes: boolean = false;
  public reportData: any;
  public loadFilterTask: any;
  public rawData: any;
  public get loadFilter() {
    return this._loadFilters;
  }
  public set loadFilter(value) {
    this._loadFilters = value;
    if (!value)
      this.loadedOrgId = null;
    if (value && this.loadedOrgId != this.authService.currentOrganisationId)
      this.loadFilterTask = this.loadData();
  }
  private loadedOrgId: any;
  constructor(private apiService: ApiService, private authService: IdentityAuthService) {
    var _th = this;
    this.authService.currentOrganisationIdObserver.subscribe(async o => {
      await _th.loadData();
    })
  }
  public applyFilter = new EventEmitter();
  public filtersLoaded = new EventEmitter();
  public advancedFilters: any = new Array();
  public tempFilters: any = new Array();
  public isOrgLoading() {
    return this.currentlyLoadingTask;
  }
  public async orgLoading() {
    if (this.currentlyLoadingTask)
      await this.currentlyLoadingTask;
    return;
  }
  public async loadData(overrideLoadFilter?: boolean) {
    if (!this.loadFilter && !overrideLoadFilter)
      return;
    this.loading = true;
    this.loadedOrgId = this.authService.currentOrganisationId;
    this.currentlyLoadingTask = this.apiService.post("/api/filters", { "IdList": [{ "key": "AssetFilter", "value": "Computer" }] }, null, appSettings.ovmApiServiceAddress).toPromise();
    var o = await this.currentlyLoadingTask;
    this.currentlyLoadingTask = null;
    if (o) {
      var o = this.formatData(o);
    }
    this.advancedFilters = o;
    this.rawData = o;
    this.tempFilters = JSON.parse(JSON.stringify(this.advancedFilters));

    this.filtersLoaded.next(this.advancedFilters);
    this.loading = false;
  }

  public applyTemp() {
    this.advancedFilters = JSON.parse(JSON.stringify(this.tempFilters));
  }
  public formatData(o, ignoreDefaults?: boolean) {
    var filt = o.filter(o => { return o.type == "ThresholdFilter" });
    var assetFilters = o.filter(o => { return o.type == "AssetFilters" });
    if (assetFilters.length > 0) {

      if (filt.length > 0) {
        assetFilters[0].items.push({
          name: "Asset Visibility",
          selected: false,
          sortOrder: 2,
          type: "ThresholdFilter",
          items: [filt[0]]
        });
      }
    }

    o.forEach(i => {
      i.expanded = true;
      if (i.items) {
        i.items.forEach(q => {
          q.expanded = false;
        })
      }




    })
    if (!ignoreDefaults)
      this.setDefaults(o);

    if (this.includeAllCheckboxes) {
      o.forEach(i => {
        var cur = i.name;
        if (i.items) {
          i.items.forEach(z => {
            if (z.items && ((cur == 'Asset Filters' && this.excludeAssetFilterNameIncludeAll.indexOf(z.name) == -1) || (cur == 'Vulnerability Filters' && this.excludeVulnerabilityFilterNameIncludeAll.indexOf(z.name) == -1)) && z.items[0].name != 'Include All') {
              z.items.unshift({ id: z.items[0].id && z.items[0].id.length < 36 ? '0' : '00000000-0000-0000-0000-000000000000', name: 'Include All' });
            }
          })
        }
      })
    }
    return o;
  }
  private excludeAssetFilterNameIncludeAll = ["Asset Status", "Asset Owner (Default)", "Authentication Status"]
  private excludeVulnerabilityFilterNameIncludeAll = ["Risk Rating", "Vulnerability Status", "Assigned Owner"]
  public setDefaults(o) {
    o.forEach(i => {
      if (i.type == "VulnerabilityFilters") {
        i.items.forEach(q => {
          if (q.type == "RiskRatings") {
            q.items.forEach(u => {
              if (u.name != "Critical" && u.name != "High" && u.name != "Medium") u.selected = false
            });
          }
          if (q.type == "Statuses" && q.name == "Vulnerability Status") {
            q.items.forEach(u => {
              if (u.name != "New" && u.name != "Under Review" && u.name != "Assigned") u.selected = false
            });
          }
        });
      }
    })

  }
  public async setTempFiltersExternal(dat) {
    if (this.loadFilterTask)
      await this.loadFilterTask;

    this.deselectAll();
    var o = this.formatData(dat, true);
    this.setSavedValues(o);
    //this.tempFilters = o;
    //this.loading = false;
  }

  public async waitForLoad() {
    if (this.loadFilterTask)
      await this.loadFilterTask;
  }

  public setSavedValues(values) {
    values.forEach(z => {
      var filtered = this.tempFilters.filter(f => { return f.type == z.type });
      if (filtered.length > 0) {
        if (filtered[0].type == 'AdvancedFilters') {
          filtered[0].items = new Array();
          filtered[0].grouped = new Array();
          z.items.forEach(o => {
            filtered[0].items.push(o);
          });
          z.grouped.forEach(o => {
            filtered[0].grouped.push(o);
          });
        }
        else {
          if (filtered[0].items) {
            if (z.items) {
              z.items.forEach(o => {
                if (o.items) {
                  var filtered2 = filtered[0].items.filter(f => { return f.type == o.type && f.id == o.id });
                  if (filtered2.length > 0) {
                    filtered2[0].selected = o.selected;
                    if (typeof filtered2[0].daysValue != undefined)
                      filtered2[0].daysValue = o.daysValue;

                    o.items.forEach(i => {
                      if (i.selected) {
                        var filtered3 = filtered2[0].items.filter(f => { return f.type == i.type && f.id == i.id });
                        if (filtered3.length > 0) {
                          filtered3[0].selected = i.selected;
                          if (typeof filtered3[0].daysValue != undefined)
                            filtered3[0].daysValue = i.daysValue;
                        }
                        else {
                          debugger;
                        }
                      }
                    })
                  }
                  else {
                    debugger;
                  }
                }
              })

            }
          }
        }
      }
      else {
        debugger;
      }
    });
    this.validateIncludeAll();
  }

  public validateIncludeAll() {
    this.tempFilters.forEach(z => {
      if (z.items) {
        z.items.forEach(o => {

          if (o.items) {
            if (o.items[0].id && (o.items[0].id == '0' || o.items[0].id == '00000000-0000-0000-0000-000000000000') && o.items[0].selected) {
              o.items.forEach(i => {
                if (!i.selected)
                  i.selected = true;
              })
            }
            else {
              var allSelected = true;
              o.items.filter(q => {
                return !(q.id && (q.id != '0' || o.items[0].id == '00000000-0000-0000-0000-000000000000'))
              }).forEach(i => {
                if (!i.selected)
                  allSelected = false;
              })
              if (allSelected && o.items[0].id && (o.items[0].id == '0' || o.items[0].id == '00000000-0000-0000-0000-000000000000') && !o.items[0].selected)
                o.items[0].selected = true;
            }
          }
        })
      }
    });
  }

  public selectAll() {
    this.tempFilters.forEach(z => {
      if (z.items) {
        z.items.forEach(o => {
          if (o.items) {
            o.items.forEach(i => {
              i.selected = true;
            })
          }
        })
      }
    });
  }
  public deselectAll() {
    this.tempFilters.forEach(z => {
      if (z.items) {
        z.items.forEach(o => {
          if (o.items) {
            o.items.forEach(i => {
              i.selected = false;
            })
          }
        })
      }
    });
  }

  public getAdvancedFilters(filters) {
    var containsAdvanced = filters.filter(o => { return o.type == "AdvancedFilters" });
    if (containsAdvanced.length == 0)
      filters.push({ type: "AdvancedFilters", name: "Asset Filters (Advanced)", items: [], grouped: [] })
    else {
      var grouped = _.groupBy(containsAdvanced[0].items, 'groupId');
      containsAdvanced[0].grouped = new Array()
      Object.keys(grouped).forEach(o => {
        containsAdvanced[0].grouped.push({ groupId: o, items: grouped[o] })
      })
    }
  }

  public calcAdvancedFilters() {
    var containsAdvanced = this.advancedFilters.filter(o => { return o.type == "AdvancedFilters" });
    containsAdvanced[0].items = new Array();
    containsAdvanced[0].grouped.forEach(grp => {
      grp.items.forEach(o => {
        o.groupId = grp.groupId
        containsAdvanced[0].items.push(o)
      })
    })
    delete containsAdvanced[0]['grouped'];
  }

  public getFriendlyAdvancedFilterDisplay(filters) {
    var arr = new Array();
    var grouped = _.groupBy(filters, 'groupId')
    Object.keys(grouped).forEach(o => {
      arr.push({
        groupId: o, values: grouped[o].map(o => {
          if (o.values) {
            o.value = '';
            o.values.forEach((v,ind) => {
              o.value += v.name + (ind < o.values.length - 1 ? ' OR ' : '')
            })
          }
          switch (o.name) {
            case 'Ipv4Address':
              o.name = 'IPv4 Address'; break;
            case 'Ipv6Address':
              o.name = 'IPv6 Address'; break;
            case 'HostName':
              o.name = 'Hostname';
              break;
            case 'DomainName':
              o.name = 'Domain Name';
              break;
            case 'OperatingSystem':
              o.name = 'Operating System';
              break;
          };
          switch (o.type) {
            case 'Contains':
              o.type = 'contains';
              break;
            case 'StartsWith':
              o.type = 'starts with';
              break;
            case 'EndsWith':
              o.type = 'ends with';
              break;
            case 'TextAt':
              return {
                Name: `<span class='mf-underline'>${o.name}</span> has text <span class='mf-underline'>${o.value}</span> from position <span class='mf-underline'>${o.lowerValue}</span>`, hasDaysValue: false
              }
            case 'InRange':
              o.type = 'is in range';
              break;
            case 'NotInRange':
              o.type = 'is not in range';
              break;
          };
          return {
            Name: `<span class='mf-underline'>${o.name}</span> ${o.type} <span class='mf-underline'>${o.value}</span>`, hasDaysValue: false
          }
        }) })
    })
    return arr;
  }
}
